import {useStaticQuery, graphql} from 'gatsby';

export const useMenu = () => {
  const allMdx = useStaticQuery(graphql`
    {
      headerMenu: allMenuYaml(filter: {fields: {type: {eq: "header"}}}) {
        nodes {
          navigation {
            label
            target
            page {
              id
              fields {
                slug
              }
              frontmatter {
                isHome
                title
              }
            }
          }
        }
      }
      footerMenu: allMenuYaml(filter: {fields: {type: {eq: "footer"}}}) {
        nodes {
          navigation {
            label
            target
            page {
              id
              fields {
                slug
              }
              frontmatter {
                isHome
                title
              }
            }
          }
        }
      }
    }
  `);
  return allMdx;
};

export default useMenu;
